import { useEffect } from "react";

function apiOrigin(): string {
    const base = process.env.REACT_APP_BASE_URL || "https://api.theplug.co/";
    return base.replace(/\/$/, "");
}

/**
 * Sends all visitors to the canonical Terms document served by the API (Express + terms.pug).
 */
const TermsPageRedirect = () => {
    useEffect(() => {
        window.location.replace(`${apiOrigin()}/terms`);
    }, []);
    return null;
};

export default TermsPageRedirect;
